import React from "react";

const IconAddition = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={18}
      viewBox="0 0 17 18"
      fill="none"
      {...props}
    >
      <path
        d="M7.1915 7.8248V0.773926H9.54179V7.8248H16.5927V10.1751H9.54179V17.226H7.1915V10.1751H0.140625V7.8248H7.1915Z"
        fill="white"
      />
    </svg>
  );
};

export default IconAddition;
